<template>
	<div class="sa-flexbox">
		<div class="sa-flexbox-header">
			<div class="sa-page-search-component">
				<b-form style="width: 100%" @submit.prevent="onClickDescrizioneFarmaco">
					<b-row class="sa-form-btn-filter">
						<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
							<!-- <label class="sa-label-data">Nome Commerciale</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.descrizione"
									placeholder="Nome Commerciale..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
							<!-- <label class="sa-label-data">Nome Commerciale</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.principioAttivo"
									placeholder="Principio Attivo" />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="2" xl="2">
							<!-- <label class="sa-label-data">Codice A.I.C.</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.codiceProdotto"
									placeholder="Codice A.I.C...." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="2" xl="2">
							<!-- <label class="sa-label-data">Codice A.T.C</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.atcGmp"
									placeholder="Codice A.T.C..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="p-2">
							<!-- <label class="sa-label-data">Nome Commerciale</label> -->
							<div class="sa-page-search-component-wrapper">
								<b-form-group label-size="sm" class="mb-0">
									<template #label>
										<label class="sa-label-data">Tipologia</label>
									</template>
									<b-form-checkbox-group v-model="tipologiaProdottoCheckBox"
										:options="tipologiaProdottoOptions" switches class="d-flex flex-wrap gap-2 mt-1"
										size="sm"></b-form-checkbox-group>

								</b-form-group>
							</div>
						</b-col>
					</b-row>
				</b-form>
			</div>
		</div>
		<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
			<b-col lg="3">
				<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
			</b-col>
			<b-col lg="9">
				<b-pagination v-model="page" :total-rows="rows" :per-page="perPage" align="right"
					size="sm"></b-pagination>
			</b-col>
		</b-row>
		<div class="sa-flexbox-body">
			<div class="b-table-sticky-header">
				<b-table id="tabellaFarmaci" :busy="isBusy" sticky-header stacked="lg" striped hover
					:items="itemsFarmaci" :fields="fieldsFarmaci" :current-page="1" selectable select-mode="single"
					@row-selected="onRowSelectedFarmaco" sort-icon-left head-variant="light" class="sa-b-table">
					<template #table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong style="padding-left: 10px">Caricamento dati in corso...</strong>
						</div>
					</template>
					<template #cell(index)="row">
						<span> {{ (page - 1) * perPage + row.index + 1 }} </span>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-flexbox-footer">
			<div class="sa-flexbox-footer-bar">
				<div class="sa-flexbox-footer-bar-separator"></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-danger"
						@click="onClickChiudi()">Annulla Selezione</b-button></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-success"
						@click="onClickConferma()" :disabled="isBusy">Conferma Selezione</b-button></div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
	data() {
		return {
			pathResourceFarmaci: "/farmaci",
			filtroFarmaci: { descrizione: null, aicCode: null, page: null, forPage: null, tipoProdotto: "" },
			rows: 0,
			page: 1,
			perPage: 100,
			tipologiaProdottoCheckBox: ['F', 'P', 'D', 'E', 'H', 'G'],
			tipologiaProdottoOptions:
				[
					{ text: 'Farmaco', value: 'F' },
					{ text: 'Parafarmaco', value: 'P' },
					{ text: 'Dispositivo Medico', value: 'D' },
					{ text: 'Extracof', value: 'E' },
					{ text: 'Galenico', value: 'G' },
					{ text: 'Omeopatico', value: 'H' },
					{ text: 'Integratore / Altro', value: 'Q' }],
			farmacoSelezionato: null,
			schedaFarmaco: null,
			isBusy: false,
			itemsFarmaci: [],
			fieldsFarmaci: [
				{
					label: "*",
					key: "index",
					thStyle: "width: 0.5rem",
				},
				{
					label: "Nome Farmaco",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "A.I.C,",
					key: "codiceProdotto",
					sortable: true,
					thStyle: "width: 7rem",
				},
				{
					label: "ATC",
					key: "atcGmp",
					sortable: true,
					thStyle: "width: 7rem",
				},
				{
					label: "Prezzo",
					key: "euroPrezzo1",
					sortable: true,
					thStyle: "width: 7rem",
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
				},
			],
		};
	},
	watch: {
		page() {
			let me = this;
			me.ricercaFarmaco();
		}
	},
	methods: {
		onRowSelectedFarmaco(item) {
			let me = this;
			console.log(item);
			if (item.length > 0) {
				me.farmacoSelezionato = item[0];
			}
		},
		onClickChiudi() {
			this.$emit("annullaSelezione");
		},
		onClickConferma() {
			this.$emit("confermaSelezione", this.farmacoSelezionato);
		},
		onClickDescrizioneFarmaco() {
			let me = this;
			me.ricercaFarmaco();
		},
		ricercaFarmaco() {
			let me = this;
			me.isBusy = true;
			me.filtroFarmaci.page = me.page;
			me.filtroFarmaci.forPage = me.perPage;
			this.filtroFarmaci.tipoProdotto = this.tipologiaProdottoCheckBox.join(",");

			let link = process.env.VUE_APP_PATH_API + me.pathResourceFarmaci;
			axios.get(link, { params: this.filtroFarmaci })
				.then((response) => {
					me.itemsFarmaci = response.data.data.list;
					me.rows = response.data.data.list.length;
					me.isBusy = false;
				})
				.catch((error) => {
					me.itemsFarmaci = [];
					me.isBusy = false;
					error;
					let messaggio = "Errore"
					toast.error(messaggio);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.sa-page-search-component-btn-search {
	right: 0px !important;
	top: 0px !important;
}

.sa-label-info {}
</style>
